import React from 'react'
import { useCategory } from '../../Hook/App'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
function Index({ callback, back, search = true }) {

    const { categoreis, category, navigate, setData, filter, setCategory } = useCategory();

    const goto = (item, link = false) => {
        if (!item) {

            if (callback) {
                callback(null);
                return;
            }
            setData('category', null, null, true);
            setData('filter', null, 'data', true)
            navigate('/ProductList', { state: { category: null } })
            return;
        }
        if (!link ^ item.children) {
            if (item.children.length) {
                setCategory(item);
                return;
            }
        }

        if (callback) {
            callback(item);
            return;
        } else {
            setData('category', item, null, true);
            setData('filter', { category_id: item.id }, 'data', true)
            navigate('/ProductList', { state: { category: item } })
            return;
        }
    }

    const Item = ({ item, sub }) => {

        if (sub) {

            return (
                <span onClick={() => { goto(item.all ? null : item) }} className="item d-flex align-items-center">
                    <span>{item.title}</span>
                    {item.children && item.children.length ? <i style={{ fontSize: 18 }} className='far fa-angle-left ms-auto'></i> : null}
                </span>
            )
        }
        return (
            <span onClick={() => { goto(item) }} state={{ category: item }} className="item d-flex align-items-center">
                {item.meta_data && item.meta_data.icon && <img src={item.meta_data.icon} alt={item.title} className="me-3" style={{ width: 40, height: 40, objectFit: "contain", borderRadius: '100%' }} />}
                <span>{item.title}</span>
                {item.children && item.children.length ? <i style={{ fontSize: 18 }} className='far fa-angle-left ms-auto'></i> : null}
            </span>
        );
    }

    return (
        <Layout nav={false}>
            <HeaderMain lable={"انتخاب گروه بندی"} back={back} leftitem={search ? <i onClick={() => { navigate('/Search') }} className='far fa-search'></i> : null} />
            <div className="category-main pt-5 mt-3">
                {category &&
                    <span onClick={() => goto(category, true)} className="title d-block">
                        <div className="d-flex align-items-center">
                            {category.meta_data && category.meta_data.icon && <img src={category.meta_data.icon} alt={category.title} className="me-3" style={{ width: 40, height: 40, objectFit: "contain", borderRadius: '100%' }} />}
                            <span>همه دسته های  {category.title} </span>
                        </div>
                    </span>
                }
                {category ?
                    category.children &&
                    category.children.map((item, i) => <Item item={item} key={i} sub />)
                    :
                    categoreis &&
                    <>
                        <Item item={{ title: "همه گروه بندی ها", all: true }} sub />
                        {categoreis.map((item, i) => {

                            return <Item item={item} key={i} />

                        })}
                    </>
                }
            </div>
        </Layout>
    )
}

export default Index